import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@e2n/ui/v2';

import { buildLink } from '@/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function CancelDialog({
  triggerComponent,
}: {
  triggerComponent: React.ReactNode;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const navigateBack = () => {
    window.location.replace(buildLink('mitarbeiterListe'));
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{triggerComponent}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t('domain.mitarbeiter.create.dialogTitle')}
          </DialogTitle>
          <DialogDescription className="text-neutrals-700">
            {t('domain.mitarbeiter.create.dialogText')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-4 ml-auto">
          <Button variant="outline" onClick={navigateBack}>
            {t('domain.mitarbeiter.create.submitDialog')}
          </Button>
          <Button onClick={() => setOpen(false)}>
            {t('domain.mitarbeiter.create.cancelDialog')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
